
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import Dialog from "@/components/UI/Dialog.vue";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import {
  addPresetToElement,
  addPresetToStoreAndSavePresetsToWordPressIfPresetsPanelIsClosed,
  createElementPresetFromName
} from "@/lib/presets/presets";
import { findNode } from "@/lib/tree/tree";
import { configStore, documentStore } from "@/store/store";
import { getRandomString } from "@/util/random-string";

@Component({ components: { Dialog, TextInput } })
export default class PresetDialog extends Vue {
  @Prop({ required: true })
  elementId!: number | null;

  @Prop({ default: false })
  open!: boolean;

  presetName: string | null = null;

  get isPresetsOverridesEnabled() {
    return configStore.isExperimentEnabled("design-presets-overrides");
  }

  get element() {
    if (!this.elementId) return null;
    return findNode(documentStore.document.tree, this.elementId);
  }

  @Watch("open")
  onOpenChange() {
    if (this.open) {
      this.presetName = this.getDefaultName();
      this.$nextTick(() => this.focusAndSelectInput());
    }
  }

  getDefaultName() {
    if (!this.element) return "";
    const type = this.element.data.type;
    const name = configStore.element(type).name;
    return `${name} ${getRandomString()}`;
  }

  focusAndSelectInput() {
    const inputEl = this.$refs.input as TextInput;
    const input = inputEl.$el.querySelector("input");
    input?.focus();
    input?.select();
  }

  async save(event: Event) {
    event.preventDefault();

    if (!this.presetName || !this.elementId || !this.element) return;

    const type = this.element.data.type;
    const preset = createElementPresetFromName(
      this.presetName,
      type,
      this.element.data.properties.design
    );

    addPresetToStoreAndSavePresetsToWordPressIfPresetsPanelIsClosed(preset);
    addPresetToElement(preset.id, this.elementId);

    this.presetName = "";
    this.$emit("close");
  }
}
